<template>
    <div>
        <owners-form :getOwnersList="getOwnersList" ref="ownersFormModal"></owners-form>
        <add-new-law-client-form :getOwnersList="getOwnersList" ref="addNewLawClientFormModal"></add-new-law-client-form>
        <clients-reports-form ref="clientsReportsFormModal"></clients-reports-form>
        <b-row class="align-items-center">
            <b-col class="d-flex align-items-center col-lg-8">
                <div class="mr-1">
                    <label for="owner-name-input">{{ $t('others.search_name') }}</label>
                    <b-form-input size="sm" v-model="name" v-on:keyup.enter="getOwnersList()" :placeholder="$t('owners.name')" type="text" class="d-inline-block mb-2" />
                </div>
    
                <div class="mr-1">
                    <label for="owner-country-input">{{ $t('owners.country') }}</label>
                    <b-form-select id="owner-country-input" v-model="countrySelect" size="sm" value-field="id" text-field="name" :options="countryOption" class="mb-2" />
                </div>
            </b-col>
            <b-col class="d-flex justify-content-end col-lg-4">
                <b-button style="float:right;" class="mr-1" size="sm" variant="outline-primary" @click="getOwnersList()" v-on:keyup.enter="getOwnersList()">{{ $t('owners.list') }}</b-button>
                <b-button style="float:right; border-color:#6B7280; color:#374151;" class="mr-1" size="sm" variant="outline-secondary" @click="addNewLawOwners(0)">{{ $t('owners.add') }}</b-button>
                <b-button style="float:right; border-color:#6B7280; color:#374151;" size="sm" variant="outline-secondary" @click="exportExcel()">{{ $t('lawyerDailyworkReport.excel') }}</b-button>
            </b-col>
        </b-row>
        <!-- table -->
        <vue-good-table id="clientTable" ref="clientTable" :columns="columns" :rows="rows" :sort-options="{enabled: false}" :search-options="{ enabled: true, externalQuery: searchTerm}" 
        styleClass="vgt-table condensed tableSize" :select-options="{enabled: false, selectOnCheckboxOnly: true, selectionInfoClass: 'custom-class', selectionText: 'rows selected', 
        clearSelectionText: 'clear', disableSelectInfo: true, selectAllByGroup: true}" :pagination-options="{ enabled: true, perPage: pageLength}" theme="my-theme">
            <div slot="emptystate">
                {{ $t('dataTable.data_not_found') }}
            </div>
            <!-- Row: Table Labels -->
            <template slot="table-column" slot-scope="props">
                <span v-if="props.column.field === 'name'" class="text-nowrap">
                    {{ $t('owners.name') }}
                </span>
                <span v-else-if="props.column.field === 'files'" class="text-nowrap">
                    {{ $t('owners.files') }}
                </span>
                <span v-else-if="props.column.field === 'process'"></span>
            </template>
            <!-- Column: Table Elements -->
            <template slot="table-row" slot-scope="props">
                <!-- Column: Client Name -->
                <span v-if="props.column.field === 'client'">
                    <b-col>
                        <b-row>
                            <a href="javascript:void(0)" @click="getInfo(props.row.id, props.row.clientId)"
                               style="font-size: smaller; font-weight: bold; color: #C2410C; text-decoration: none; cursor: pointer;"
                               onmouseover="this.style.textDecoration='underline'" onmouseout="this.style.textDecoration='none'">
                                {{ props.row.client }}
                            </a>
                        </b-row>
                        <b-row v-if="props.row.clientAddress">
                            <span
                                class="wh-clamp-2"
                                style="font-size: smaller"
                                v-b-tooltip.hover="{ title: [props.row.clientAddress.address, props.row.clientAddress.country].filter(Boolean).join(' '), customClass: 'wh-tooltip' }">
                                {{ [props.row.clientAddress.address, props.row.clientAddress.country].filter(Boolean).join(' ') }}
                            </span>
                        </b-row>
                    </b-col>
                </span>
                <!-- Column: Files (total) -->
                <span v-else-if="props.column.field === 'files'">
                    <a v-if="props.row.totalMatterCount > 0" href="javascript:void(0)"
                       :title="props.row.totalMatterCount + ' dosya · ' + props.row.totalProcessCount + ' işlem'"
                       @click="showAllFiles(props.row)"
                       style="color: #C2410C; text-decoration: none; cursor: pointer; font-weight: bold;"
                       onmouseover="this.style.textDecoration='underline'" onmouseout="this.style.textDecoration='none'">
                        {{ props.row.totalMatterCount }}
                    </a>
                    <span v-else style="color: #9CA3AF;">0</span>
                </span>
            </template>
            <!-- pagination -->
            <template slot="pagination-bottom" slot-scope="props">
                <div class="d-flex justify-content-between flex-wrap">
                    <div class="d-flex align-items-center mb-0 mt-1">
                        <span class="text-nowrap"> {{ $t('dataTable.total') }} {{ total }} {{ $t('dataTable.record') }}
                        </span>
                    </div>
                    <div>
                        <b-pagination :value="1" :total-rows="total" v-model="pageNo" :per-page="pageLength" first-number last-number align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0" @input="(value) => getOwnersList()">
                            <template #prev-text>
                                <feather-icon icon="ChevronLeftIcon" size="18" />
                            </template>
                            <template #next-text>
                                <feather-icon icon="ChevronRightIcon" size="18" />
                            </template>
                        </b-pagination>
                    </div>
                </div>
            </template>
        </vue-good-table>
    </div>
    </template>
    
    <script>
    export default {
        data() {
            return {
                name: "",
                countrySelect: 0,
                countryOption: [],
                total: 0,
                pageLength: 50,
                pageNo: 1,
                dir: false,
                clientAddress: '',
                columns: [
                    {
                        label: this.$t('owners.name'),
                        field: `client`,
                    },
                    {
                        label: this.$t('owners.files'),
                        field: `files`,
                    },
                ],
                rows: [],
                searchTerm: '',
                agentOwnerSelect: 0,
                searchDebounce: null,
                requestSeq: 0
            }
        },
        mounted() {
            this.getOwnersList()
        },
        watch: {
            name() { this.debouncedSearch() }
        },
        methods: {
            debouncedSearch() {
                clearTimeout(this.searchDebounce)
                this.searchDebounce = setTimeout(() => {
                    this.pageNo = 1
                    this.getOwnersList()
                }, 300)
            },
            showDetailList(clientType, lawMatterTypeId, id) {
                if(id != 0){
                    this.$refs.clientsReportsFormModal.showInfo(clientType, lawMatterTypeId, id)
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                    this.getOwnersList()
                }
            },
            showAllFiles(row) {
                this.$refs.clientsReportsFormModal.showInfo(2, 0, row.clientId, row.client)
            },
            async deleted(data) {
                data = { id: data.id}
                const controller = { name: 'LawClient'}
                const payload = { data: data, controller: controller}
                this.$DeleteConfirm().then(result => {
                    if (result.value) {
                        this.$store.dispatch('moduleAuth/delete', payload).then((response) => {
                            if (response.data.resultStatus == true) {
                                this.$DeleteAlert()
                                this.getOwnersList()
                            } else {
                                this.$WarningAlert(response.data.resultMessage)
                                this.getOwnersList()
                            }
                        })
                    }
                })
            },
            async getInfo(id,clientId) {
                this.$refs.ownersFormModal.showInfo(id,clientId)
            },
            addNewLawOwners() {
                this.$refs.addNewLawClientFormModal.showInfo(false)
            },
            getOwnersList() {
                const requestSeq = ++this.requestSeq
                const controller = { name: 'LawClient'}
                const data = { clientName: this.name,  pageLength: this.pageLength, pageNo: this.pageNo, isOwner: true, countryId: this.countrySelect}
                const payload = { data: data, controller: controller}
                this.$store.dispatch('moduleAuth/getList', payload).then((response) => {
                    // Daha yeni bir istek gonderildiyse bu yanit bayattir, uygulanmaz
                    if (requestSeq !== this.requestSeq) return
                    if (response.data.resultStatus == true) {
                        this.total = response.data.total
                        this.countrySelect = this.countrySelect
                        this.countryOption = response.data.countryList
                        this.countryOption.splice(0, 0, this.$nullSelected())
    
                        this.rows = response.data.lawClientList
                    } else {
                        this.$WarningAlert(response.data.resultMessage)
                    }
                })
            },
            exportExcel() {
                const controller = { name: 'LawClient', actionName: 'CanExport'}
                const data = { columnList: this.columns, DataList: this.rows}
                const payload = { data: data, controller: controller }
                this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                    if (response.data.resultStatus == true) {
                        this.$downloadFile("Clients", response.data.base64, 'xlsx')
                    } else {
                        this.$WarningAlert(response.data.resultMessage)
                    }
                })
            }
        },
    }
    </script>
    
    <style lang="scss">
    .excel-css {
        float: right;
        margin-right: 1em;
        width: 9.5em;
        color: #7367f0;
        border: 1px solid #7367f0;
        background-color: transparent;
        margin-left: 1em;
        height: 2em;
        border-radius: 0.358rem;
    }
    
    [dir] .dark-layout .card {
        background-color: #252d3f !important;
        box-shadow: 0 4px 24px 0 rgb(34 41 47 / 24%) !important;
    }
    
    .custom-checkbox .custom-control-label,
    .custom-radio .custom-control-label {
        font-size: 1rem;
        position: static;
        inline-size: max-content !important;
    }
    </style>
    